module.exports = __webpack_public_path__ + "static/media/value-prop-icon-2.9e505229.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value-prop-icon-2.svg
// module id = 2661
// module chunks = 0